/**
     * EngineStatusChanged.contract.ts — Event Contract System™ (generation v1).
     * An engine's lifecycle status changed (running/disabled/unregistered or health-sweep status).
     */

    import type { EventContract } from '../EventContractRegistry';

    export const EngineStatusChangedContract: EventContract = {
      name: 'EngineStatusChanged',
      version: 1,
      description: "An engine's lifecycle status changed (running/disabled/unregistered or health-sweep status).",
      publishers: ["core"],
      subscribers: ["plugin-registry"],
      fields: [
        { name: 'engineId', type: 'string', required: true, description: "Engine adapter id" },
    { name: 'status', type: 'string', required: true, description: "New status label" },
      ],
      allowExtraFields: false,
      timestampPolicy: "Status transition time (now at the mutation site).",
      stability: 'stable',
      deprecated: false,
      example: {"engineId":"fusion","status":"running"},
    };
    